import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, List, ListItem, ListItemIcon, ListItemText, Stack, Typography, } from '@mui/material';
import { addGeofenceCheckedId, addGeofenceCheckedItemsId, deleteGeofenceCheckedId, setGeofenceCheckedId } from 'app/actions/map';
import { Autosizer, Scrollbar } from 'app/components';
import { geofenceCheckedIdMapSelector, geofenceSearchValueMapSelector, refMapSelector, sortItemsFilterGeofenceListSelector, sortItemsFlatMapSelector, } from 'app/selectors/map';
import React, { forwardRef, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
const MapFilterGeofenceList = () => {
    const listRef = useRef(null);
    const dispatch = useDispatch();
    const mapRef = useSelector(refMapSelector);
    const geofenceSearchValue = useSelector(geofenceSearchValueMapSelector);
    const geofenceCheckedId = useSelector(geofenceCheckedIdMapSelector);
    const sortItems = useSelector(sortItemsFilterGeofenceListSelector);
    const sortItemsFlat = useSelector(sortItemsFlatMapSelector);
    const [expanded, setExpanded] = useState(-1);
    const handleAccordionChange = (key) => (event, expanded) => {
        setExpanded(expanded ? key : null);
    };
    const handleItemClick = (event, value) => {
        var _a, _b, _c, _d;
        event.preventDefault();
        event.stopPropagation();
        if (geofenceCheckedId.indexOf(value) === -1) {
            dispatch(addGeofenceCheckedId(value.id));
        }
        (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [value.latitude, value.longitude]);
    };
    const handleCheckboxItemClick = (event, id) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(geofenceCheckedId.indexOf(id) !== -1 ? deleteGeofenceCheckedId(id) : addGeofenceCheckedId(id));
    };
    const handleCheckboxSummaryClick = (event, key) => {
        event.preventDefault();
        event.stopPropagation();
        const filterItems = sortItems[key].geofences.map((i) => i.id).filter((id) => geofenceCheckedId.indexOf(id) === -1);
        const checkedItems = geofenceCheckedId.filter((id) => sortItems[key].geofences.map((i) => i.id).indexOf(id) === -1);
        dispatch(filterItems.length ? addGeofenceCheckedItemsId(filterItems) : setGeofenceCheckedId(checkedItems));
    };
    const filteredIds = useMemo(() => {
        if (geofenceSearchValue.length === 0) {
            return sortItems.flatMap((group) => group.geofences.map((g) => g.id));
        }
        else {
            return sortItemsFlat.map((item) => item.id);
        }
    }, [geofenceSearchValue, sortItems, sortItemsFlat]);
    const handleSelectAll = () => {
        const allSelected = filteredIds.length > 0 && filteredIds.every((id) => geofenceCheckedId.includes(id));
        if (allSelected) {
            const remainingChecked = geofenceCheckedId.filter((id) => !filteredIds.includes(id));
            dispatch(setGeofenceCheckedId(remainingChecked));
        }
        else {
            const newIds = filteredIds.filter((id) => !geofenceCheckedId.includes(id));
            dispatch(addGeofenceCheckedItemsId(newIds));
        }
    };
    const allSelected = filteredIds.length > 0 && filteredIds.every((id) => geofenceCheckedId.includes(id));
    const someSelected = filteredIds.some((id) => geofenceCheckedId.includes(id)) && !allSelected;
    return (React.createElement(Box, { sx: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
        } },
        React.createElement(Box, { sx: (theme) => ({
                flexShrink: 0,
                padding: theme.spacing(1, 2),
                borderBottom: `1px solid ${theme.palette.divider}`,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover': {
                    bgcolor: 'background.default',
                },
            }), onClick: handleSelectAll },
            React.createElement(Checkbox, { size: 'small', color: 'primary', disableRipple: true, checked: allSelected, indeterminate: someSelected, sx: {
                    padding: 0,
                    svg: {
                        fontSize: '18px',
                    },
                } }),
            React.createElement(Typography, { sx: { ml: 1 } }, "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0451")),
        geofenceSearchValue.length === 0 && (React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                flex: '1 1 auto',
                minHeight: 0,
                overflow: 'hidden',
                '.simplebar-content-wrapper': {
                    padding: theme.spacing(0),
                },
                '.MuiAccordion-root': {
                    borderRadius: '0',
                    overflow: 'hidden',
                    transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
                    '&:before': {
                        display: 'none',
                    },
                    '&:last-of-type': {
                        margin: '0!important',
                    },
                    '&.Mui-expanded': {
                        margin: '0',
                    },
                    '&.Mui-disabled': {
                        bgcolor: 'background.paper',
                        '.MuiAccordionSummary-root': {
                            opacity: '1',
                        },
                        '.MuiAccordionSummary-expandIconWrapper': {
                            display: 'none',
                        },
                    },
                    '.MuiAccordionSummary-expandIconWrapper': {
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiAccordionSummary-root': {
                    padding: theme.spacing(0, 2),
                    minHeight: '24px',
                    transition: 'none',
                    '&:hover': {
                        bgcolor: 'background.default',
                        borderRadius: '0',
                    },
                    '&.Mui-expanded': {
                        minHeight: '24px',
                        bgcolor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '0',
                        '.MuiCheckbox-root': {
                            color: '#FFFFFF',
                            '&.Mui-checked': {
                                color: '#FFFFFF',
                            },
                        },
                        '.MuiAccordionSummary-expandIconWrapper': {
                            color: '#FFFFFF',
                        },
                    },
                },
                '.MuiAccordionSummary-content': {
                    alignItems: 'center',
                    overflow: 'hidden',
                    margin: theme.spacing(0),
                    '&.Mui-expanded': {
                        margin: theme.spacing(0),
                    },
                    '.MuiCheckbox-root': {
                        minWidth: '26px',
                        justifyContent: 'flex-start',
                        padding: theme.spacing(0),
                        svg: {
                            fontSize: '18px',
                        },
                    },
                },
                '.MuiAccordionDetails-root': {
                    padding: theme.spacing(0),
                    '.MuiList-root': {
                        margin: '2px 0',
                    },
                },
            }) },
            React.createElement(Scrollbar, null, sortItems.map(({ id, name, geofences }, key) => {
                const checkedFilter = geofences.filter((i) => geofenceCheckedId.indexOf(i.id) !== -1);
                return (React.createElement(Accordion, { key: id, square: true, elevation: 0, disabled: geofences.length === 0, expanded: expanded === key, onChange: handleAccordionChange(key), TransitionProps: { unmountOnExit: true } },
                    React.createElement(AccordionSummary, { disableRipple: true, expandIcon: React.createElement(ExpandMore, null) },
                        React.createElement(Checkbox, { size: 'small', color: 'primary', disableRipple: true, disabled: geofences.length === 0, checked: geofences.length !== 0 && checkedFilter.length === geofences.length, indeterminate: checkedFilter.length !== 0 && checkedFilter.length < geofences.length, onClick: (event) => handleCheckboxSummaryClick(event, key) }),
                        React.createElement(Typography, null,
                            name,
                            " (",
                            geofences.length,
                            ")")),
                    React.createElement(AccordionDetails, null,
                        React.createElement(List, { disablePadding: true }, geofences.map((geofence, key) => (React.createElement(ListItem, { key: key, disablePadding: true, onClick: (event) => handleItemClick(event, geofence), sx: (theme) => ({
                                padding: theme.spacing(0.5, 1),
                                paddingLeft: '36px',
                                borderRadius: '0',
                                '&:hover': {
                                    bgcolor: 'background.default',
                                    cursor: 'pointer',
                                },
                                '.MuiListItemIcon-root': {
                                    minWidth: '26px',
                                    '.MuiCheckbox-root': {
                                        padding: '0',
                                        minWidth: '26px',
                                        justifyContent: 'flex-start',
                                        svg: {
                                            fontSize: '18px',
                                        },
                                    },
                                },
                                '.MuiListItemText-root': {
                                    margin: theme.spacing(0),
                                },
                            }) },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Checkbox, { size: 'small', color: 'primary', disableRipple: true, checked: geofenceCheckedId.indexOf(geofence.id) !== -1, onClick: (event) => handleCheckboxItemClick(event, geofence.id) })),
                            React.createElement(ListItemText, { primary: geofence.name }))))))));
            })))),
        geofenceSearchValue.length !== 0 && (React.createElement(Box, { sx: { flex: '1 1 auto', minHeight: 0, overflow: 'hidden' } },
            React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
                React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => {
                    return (React.createElement(FixedSizeList, { ref: listRef, height: height, itemSize: 24, overscanCount: 10, innerRef: contentNodeRef, outerRef: scrollableNodeRef, innerElementType: MapFilterGeofenceListInnerElementType, itemCount: sortItemsFlat.length, itemData: {
                            items: sortItemsFlat,
                            checkedId: geofenceCheckedId,
                            onCheckboxClick: handleCheckboxItemClick,
                            onClick: handleItemClick,
                        } }, MapFilterGeofenceListItem));
                }))))))));
};
const MapFilterGeofenceListInnerElementType = forwardRef((props, ref) => (React.createElement(List, Object.assign({ ref: ref, disablePadding: true }, props))));
const MapFilterGeofenceListItem = ({ data, index, style, }) => {
    const { items, onClick, checkedId, onCheckboxClick } = data;
    return (React.createElement(ListItem, { style: style, disablePadding: true, onClick: (event) => onClick(event, items[index]), sx: (theme) => ({
            padding: theme.spacing(0.5, 1),
            paddingLeft: '12px',
            borderRadius: '0',
            '&:hover': {
                bgcolor: 'background.default',
                cursor: 'pointer',
            },
            '.MuiListItemIcon-root': {
                minWidth: '26px',
                '.MuiCheckbox-root': {
                    padding: '0',
                    minWidth: '26px',
                    justifyContent: 'flex-start',
                    svg: {
                        fontSize: '18px',
                    },
                },
            },
            '.MuiListItemText-root': {
                margin: theme.spacing(0),
            },
        }) },
        React.createElement(ListItemIcon, null,
            React.createElement(Checkbox, { size: 'small', color: 'primary', disableRipple: true, checked: checkedId.indexOf(items[index].id) !== -1, onClick: (event) => onCheckboxClick(event, items[index].id) })),
        React.createElement(ListItemText, { primary: items[index].name })));
};
export default MapFilterGeofenceList;
